import { Routes, Route, Navigate } from "react-router-dom";
import AdminDashboard from "../pages/admin/main-panel/AdminDashboard";
import NewEmployee from "../pages/admin/workers/NewEmployee.jsx";
import ManageEmployees from "../pages/admin/workers/ManageEmployees.jsx";
import EmployeeLogs from "../pages/admin/workers/EmployeeLogs.jsx";
import TotalPayments from "../pages/admin/payments/TotalPayments.jsx";
import TodaySales from "../pages/admin/payments/TodaySales.jsx";
import TotalEarnings from "../pages/admin/payments/TotalEarnings.jsx";
import AddCar from "../pages/admin/machine-modifications/AddCar.jsx";
import ManageCars from "../pages/admin/machine-modifications/ManageCars.jsx";
import ChangeLogs from "../pages/admin/machine-modifications/ChangeLogs.jsx";
import ArchivedCars from "../pages/admin/machine-modifications/ArchivedCars.jsx";
import PriceDiscount from "../pages/admin/machine-modifications/PriceDiscount.jsx";
import OilRequirements from "../pages/admin/oil-requirements/OilRequirements.jsx";
import AddProduct from "../pages/admin/products/AddProduct.jsx";
import ManageProduct from "../pages/admin/products/ManageProducts.jsx";
import ArchivedProducts from "../pages/admin/products/ArchivedProducts.jsx";
import RefundSale from "../pages/seller/sale/RefundSale.jsx";
import RefundedSales from "../pages/seller/sale/RefundedSales.jsx";
import OutOfStockProduct from "../pages/admin/products/OutOfStockProducts.jsx";
import Expenses from "../pages/admin/expenses/Expenses.jsx";
import NotFound from "../pages/shared/NotFound.jsx";
import { useLocation } from "react-router-dom";

export default function AdminRoutes() {

  const location = useLocation();

  return (
    <Routes>
      
      <Route index element={<Navigate to="sales-statistics" replace />} /> 
      <Route path="sales-statistics" element={<AdminDashboard />} />
      <Route path="new-employee" element={<NewEmployee />} />
      <Route path="manage-employees" element={<ManageEmployees />} />
      <Route path="employee-logs" element={<EmployeeLogs />} />
      <Route path="total-payments" element={<TotalPayments />} />
      <Route path="today-sales" element={<TodaySales />} /> 
      <Route path="refund" element={<TotalPayments  key={location.key} />} />
      <Route path="refunded-sales" element={<RefundedSales isAdmin={true} key={location.key} />} />
      <Route path="total-earnings" element={<TotalEarnings />} />
      <Route path="expenses" element={<Expenses />} />
      <Route path="add-car" element={<AddCar />} />
      <Route path="manage-cars"element={<ManageCars showDelete={true} />} />
      <Route path="change-logs" element={<ChangeLogs />} />
      <Route path="archived-cars" element={<ArchivedCars />} />
      <Route path="price-discount" element={<PriceDiscount />} />
      <Route path="oil-requirements" element={<OilRequirements />} />
      <Route path="add-product" element={<AddProduct />} />
      <Route path="manage-products" element={<ManageProduct />} />
      <Route path="archived-products" element={<ArchivedProducts />} />
      <Route path="out-of-stock-products" element={<OutOfStockProduct />} />
      <Route path="*" element={<NotFound />} />
      
    </Routes>
  );
}
